import { BASE_URL } from 'constants/api';
import actions from './index';

export const ACTIONS = {
  GET: 'TEACHER_CLASS_STATUS_GET',
  GET_SUCCESS: 'TEACHER_CLASS_STATUS_GET_SUCCESS',
  GET_FAILURE: 'TEACHER_CLASS_STATUS_GET_FAILURE',
};

export const get = actions.get(
  teacherClassroomId => `${BASE_URL}/classroom/teacher-classroom/${teacherClassroomId}/`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);
